import { ref, Ref } from 'vue'

import { IProduct } from '../../domain/IProduct'

import { getProductList } from '../../dependency-injection'

type ReactiveProductList = Ref<IProduct[]>

export function useProductList() {
  const productList: ReactiveProductList = ref([])

  const loadProductList = async (): Promise<void> => {
    productList.value = await getProductList.execute()
  }

  return { productList, loadProductList }
}
